import React from "react";

export default function TwTooltip(props) {
  const { title, children, position = 'top' } = props
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };

  return (
    <div className="relative group max-w-max inline-flex items-center cursor-pointer">
      {children}
      <div
        className={`z-50 absolute w-max max-w-xs bg-gray-800 text-white text-sm px-3 py-1 rounded-md
                   opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-300
                   ${positionClasses[position]}`}
      >
        {title}
        <div
          className={`absolute ${position === 'top' ? 'top-full left-1/2 -translate-x-1/2 border-t-gray-800 border-4 border-transparent' : ''
            } ${position === 'bottom' ? 'bottom-full left-1/2 -translate-x-1/2 border-b-gray-800 border-4 border-transparent' : ''
            } ${position === 'left' ? 'left-full top-1/2 -translate-y-1/2 border-l-gray-800 border-4 border-transparent' : ''
            } ${position === 'right' ? 'right-full top-1/2 -translate-y-1/2 border-r-gray-800 border-4 border-transparent' : ''
            }`}
        ></div>
      </div>
    </div>
  );
}
